'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'siteHeader', () => ({

		mobileMenuOpen: false,

		lockBodyScroll() {
			const scrollY = window.scrollY || window.pageYOffset || 0;
			document.body.dataset.scrollY = String( scrollY );
			document.documentElement.classList.add( 'mobile-menu-open' );
			document.body.classList.add( 'mobile-menu-open' );
			document.body.style.position = 'fixed';
			document.body.style.top      = `-${ scrollY }px`;
			document.body.style.left     = '0';
			document.body.style.right    = '0';
			document.body.style.width    = '100%';
		},

		unlockBodyScroll() {
			const scrollY = Number( document.body.dataset.scrollY || 0 );
			document.documentElement.classList.remove( 'mobile-menu-open' );
			document.body.classList.remove( 'mobile-menu-open' );
			document.body.style.position = '';
			document.body.style.top      = '';
			document.body.style.left     = '';
			document.body.style.right    = '';
			document.body.style.width    = '';
			delete document.body.dataset.scrollY;
			window.scrollTo( 0, scrollY );
		},

		toggleMobileMenu() {
			this.mobileMenuOpen = ! this.mobileMenuOpen;

			if ( this.mobileMenuOpen ) {
				requestAnimationFrame( () => this.lockBodyScroll() );
				this.$refs.siteHeader.classList.add( 'active' );
				return;
			}

			this.$refs.siteHeader.classList.remove( 'active' );
			this.closeAllSubmenus();
			this.unlockBodyScroll();
		},

		handleEscapeKey() {

			if ( ! this.mobileMenuOpen ) return;

			this.mobileMenuOpen = false;
			this.closeAllSubmenus();
			this.unlockBodyScroll();
		},

		closeAllSubmenus() {
			this.$dispatch( 'mobile-menu-submenus-close' );
		}
	}) );
});
